import _ from 'lodash';
import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import NumberField from '../../../Base/NumberField';

const MAIN_LABELS = {
    bcm: 'BCM, m',
    scm: 'SCM, m',
    betweenManifolds: 'Between manifolds, m',
}

/** @param {object} props */
function Manifolds({ confirmed, changeField, getError, underStyle, modifiedFields, manifolds }) {
    const addRow = () => {
        const list = _.cloneDeep(manifolds.list);
        list.push({
            number: undefined,
            size: undefined,
            commonLine: undefined,
        });
        changeField({ field: 'manifolds.list', value: list });
    };
    const removeRow = (index) => {
        const list = _.cloneDeep(manifolds.list);
        list.splice(index, 1);
        changeField({ field: 'manifolds.list', value: list });
    };
    return (
        <React.Fragment>
            <div className="row">
                {Object.entries(MAIN_LABELS).map(([field, label]) => (
                    <div className='col-xs-4' key={`manifolds.${field}`}>
                        <NumberField
                            name={`manifolds.${field}`}
                            floatingLabelText={label}
                            value={manifolds[field] || ''}
                            disabled={confirmed}
                            errorText={getError(`manifolds.${field}`)}
                            fullWidth
                            floatNumber
                            onChange={(e, value) => {
                                changeField({
                                    field: `manifolds.${field}`,
                                    value,
                                    type: 'number',
                                });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes(`manifolds.${field}`) ? underStyle : null}
                        />
                    </div>
                ))}
            </div>
            {manifolds.list.map(({ number, size, commonLine }, index) => (
                <div className="row" key={`manifoldsList_${index}`}>
                    <div className='col-xs-4'>
                        <NumberField
                            name={`manifolds.list[${index}].number`}
                            floatingLabelText='Number'
                            value={number || ''}
                            disabled={confirmed}
                            errorText={getError(`manifolds.list[${index}].number`)}
                            fullWidth
                            onChange={(e, value) => {
                                changeField({
                                    field: `manifolds.list[${index}].number`,
                                    value,
                                    type: 'number',
                                });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes(`manifolds.list[${index}].number`) ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-4'>
                        <NumberField
                            name={`manifolds.list[${index}].size`}
                            floatingLabelText='Size, m'
                            value={size || ''}
                            disabled={confirmed}
                            errorText={getError(`manifolds.list[${index}].size`)}
                            fullWidth
                            floatNumber
                            onChange={(e, value) => {
                                changeField({
                                    field: `manifolds.list[${index}].size`,
                                    value,
                                    type: 'number',
                                });
                            }}
                            underlineStyle={modifiedFields && modifiedFields.includes(`manifolds.list[${index}].size`) ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <SelectField
                            value={commonLine}
                            onChange={(e, i, value) => {
                                changeField({
                                    field: `manifolds.list[${index}].commonLine`,
                                    value,
                                });
                            }}
                            disabled={confirmed}
                            name={`manifolds.list[${index}].commonLine`}
                            floatingLabelText='Common Line'
                            underlineStyle={modifiedFields && modifiedFields.includes(`manifolds.list[${index}].commonLine`) ? underStyle : null}
                            autoWidth
                            fullWidth
                        >
                            <MenuItem value={null} primaryText={undefined} />
                            <MenuItem value={true} primaryText='Yes' />
                            <MenuItem value={false} primaryText='No' />
                        </SelectField>
                    </div>
                    <div className='col-xs-1'>
                        <div style={{ margin: '25px 0 0 0' }}>
                            {index === 0 && (
                                <IconButton
                                    disabled={confirmed}
                                    onClick={addRow}
                                >
                                    <ContentAddIcon color='green' />
                                </IconButton>
                            )}
                            {index !== 0 && (
                                <IconButton
                                    disabled={confirmed}
                                    onClick={() => {
                                        removeRow(index);
                                    }}
                                >
                                    <ContentRemoveIcon color='red' />
                                </IconButton>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </React.Fragment>
    );
}

export default Manifolds;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Manifolds.jsx